module.exports = __webpack_public_path__ + "img/404.d85f4a84.png";